import { TTableData } from 'src/pages/PaymentMethods/PaymentMethods';
import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const getEntities = ({ paymentMethodsReducer }: RootState) => paymentMethodsReducer.entities;
const getTotalCount = ({ paymentMethodsReducer }: RootState) => paymentMethodsReducer.totalCount;

const getTableData = createSelector(getEntities, (entity) => {
  if (!entity.length) {
    return [];
  }

  const outputData: TTableData[] = [];
  const uniqueSystemGroups: Record<string, boolean> = {};

  entity.forEach((item) => {
    item.providers.forEach((provider) => {
      outputData.push({
        rowspan: { count: 0, name: 'systemGroupInfo' },
        systemGroupInfo: { systemGroupFormId: item.systemGroupFormId, systemGroup: item.systemGroup },
        provider: provider.name,
        integrations: provider.integrations,
      });
    });
  });

  return outputData.map((item) => {
    const { systemGroup } = item.systemGroupInfo;

    // Если группа уже была найдена, то ставлю значение 0, иначе ставлю количество элементов с таким именем системной группы
    const count = uniqueSystemGroups[systemGroup] ? 0 : outputData.filter((el) => el.systemGroupInfo.systemGroup === systemGroup).length;

    // отмечаем, что такая группа уже была найдена
    uniqueSystemGroups[systemGroup] = true;

    return {
      ...item,
      rowspan: {
        count,
        name: 'systemGroupInfo',
      },
    };
  });
});

export const paymentMethodsSelectors = { getEntities, getTotalCount, getTableData };
